const styles = () => ({
  itemToBeDeleted: {
    fontSize: 12,
  },

  warningMessage: {
    marginTop: 0,
  },

  actions: {
    background: '#FFFFFF',
  },

  deleteButton: {
    marginLeft: 20,
  },
});

export default styles;
